import { LoadingOverlay } from '@mantine/core';

type props = {
  visible: boolean;
  loaderSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
};

const CustomLoadingOverlay = ({ visible, loaderSize = 'md' }: props) => {
  return (
    <LoadingOverlay
      visible={visible}
      zIndex={1000}
      overlayProps={{ radius: 'sm', blur: 2 }}
      loaderProps={{ size: loaderSize }}
    />
  );
};

export default CustomLoadingOverlay;
